// import { useContext } from "react";
// import { createContext } from "react";
import { useSelector } from "react-redux";


// const privilagesContext = createContext();
// export const useAuth = () => {
//   console.log(privilagesContext,"privilagesContextprivilagesContextprivilagesContext");
  
//   const context = useContext(privilagesContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// }; 

export const getPrivilegeForModule = (privileges, moduleId) => {
  const filteredObj = privileges?.find((dat) => dat?.unique_id === moduleId);
  return {
    canRead: filteredObj?.read === 1,
    canCreate: filteredObj?.create === 1,
    canUpdate: filteredObj?.update === 1,
    canDelete: filteredObj?.delete === 1,
    canPrint: filteredObj?.print === 1,
    canAttach: filteredObj?.attach === 1
  };
};

export const CommonPrivFilter = (moduleId) => {
  const { privileges } = useSelector((state) => state.privilegeSlice);
  return getPrivilegeForModule(privileges, moduleId);
};

export function filterMenu(menu, privileges) {
  const predicate = (item) => !item.ref || getPrivilegeForModule(privileges, item.ref)?.canRead;

  const filtered = menu
    .map((item) => {
      const matches = predicate(item);

      // Recursively filter children if any
      let filteredChildren = [];
      if (Array.isArray(item.children)) {
        filteredChildren = filterMenu(item.children, privileges);
      }

      // Include item if:
      // - it matches, OR
      // - it has matching children
      if (matches) {
        return {
          ...item,
          children: filteredChildren?.length > 0 ? filteredChildren : undefined,
        };
      }

      // Otherwise exclude it
      return null;
    })
    .filter(Boolean); // Remove nulls

  console.log(filtered, "Filtered Menu");
  return filtered;
}
